import type { Route } from './extract-routes';

export const FALLBACK_ROUTE: Route = {
  site: 'xing',
  path: '/',
  catchAll: 'fallback',
  route: '/*fallback',
  redirectTo: undefined,
  owner: 'unknown',
  xinglet: 'unknown',
  parents: [],
  config: {},
};
